import { createAction, props } from '@ngrx/store';

export const getSponsorGroupList = createAction(
  '[SponsorGroup] Load SponsorGroupList'
);

export const getSponsorGroupListSuccess = createAction(
  '[SponsorGroup] Load SponsorGroupList Success',
  props<{ data: any}>()
);

export const getSponsorGroupListFailure = createAction(
  '[SponsorGroup] Load SponsorGroupList Failure',
  props<{ error: any }>()
);

export const getSponsorGroup = createAction(
  '[SponsorGroup] Load SponsorGroup'
);

export const getSponsorGroupSuccess = createAction(
  '[SponsorGroup] Load SponsorGroup Success',
  props<{ data: any }>()
);

export const getSponsorGroupFailure = createAction(
  '[SponsorGroup] Load SponsorGroup Failure',
  props<{ error: any }>()
);

export const createSponsorGroupList = createAction(
  '[SponsorGroup] Create SponsorGroupList'
);

export const createSponsorGroupListSuccess = createAction(
  '[SponsorGroup] Create SponsorGroupList Success',
  props<{ campaign: any, data: any }>()
);

export const createSponsorGroupListFailure = createAction(
  '[SponsorGroup] Create SponsorGroupList Failure',
  props<{ error: any }>()
);

export const updateSponsorGroupList = createAction(
  '[SponsorGroup] Update SponsorGroupList'
);

export const updateSponsorGroupListSuccess = createAction(
  '[SponsorGroup] Update SponsorGroupList Success',
  props<{ data: any }>()
);

export const updateSponsorGroupListFailure = createAction(
  '[SponsorGroup] Update SponsorGroupList Failure',
  props<{ error: any }>()
);

export const deleteSponsorGroupList = createAction(
  '[SponsorGroup] Delete SponsorGroupList'
);

export const deleteSponsorGroupListSuccess = createAction(
  '[SponsorGroup] Delete SponsorGroupList Success',
  props<any>()
);

export const deleteSponsorGroupListFailure = createAction(
  '[SponsorGroup] Delete SponsorGroupList Failure',
  props<{ error: any }>()
);

export const resetSponsorGroupList = createAction(
  '[SponsorGroup] Reset SponsorGroupList'
);

export const resetSponsorGroupListSuccess = createAction(
  '[SponsorGroup] Reset SponsorGroupList Success',
  props<any>()
);

export const resetSponsorGroupListFailure = createAction(
  '[SponsorGroup] Reset SponsorGroupList Failure',
  props<{ error: any }>()
);

export const AddSponsorGroup = createAction(
  '[Campaign] Add SponsorGroup To Campaign',
  props<any>()
);

export const AddSponsorGroupSuccess = createAction(
  '[Campaign] Add SponsorGroup To Campaign Success',
  props<any>()
);

export const AddSponsorGroupFailure = createAction(
  '[Campaign] Add SponsorGroup To Campaign Failure',
  props<any>()
);